import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import Iconify from '../Iconify';
import { compactChipStyle } from '../../styles/stepFormStyles';

const PRESETS = [
    { key: '2 hours-call', label: '2 hours' },
    { key: 'tomorrow', label: 'Tomorrow 9am' },
    { key: 'week', label: '1 week' },
    { key: 'two-week', label: '2 weeks' },
    { key: 'custom reminder', label: 'Custom' },
    { key: 'no-reminder', label: 'No reminder' },
];

const FollowUpButtonGroup = ({ activeTime, handleButtonClick }) => (
    <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap', mb: 2 }}>
        {PRESETS.map((preset) => (
            <Box key={preset.key} onClick={() => handleButtonClick(preset.key)}
                role="button" tabIndex={0} aria-pressed={activeTime === preset.key}
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleButtonClick(preset.key); } }}
                sx={{
                    ...compactChipStyle(activeTime === preset.key),
                    ...(activeTime === preset.key && preset.key === 'no-reminder' && { borderColor: '#637381', color: '#fff', background: '#637381', boxShadow: '0 2px 8px rgba(99,115,129,0.24)' }),
                }}>
                {preset.key === 'no-reminder' && <Iconify icon="mdi:bell-off-outline" width={14} sx={{ mr: 0.5 }} />}
                {preset.label}
            </Box>
        ))}
    </Box>
);

FollowUpButtonGroup.propTypes = {
    activeTime: PropTypes.string,
    handleButtonClick: PropTypes.func,
};

export default FollowUpButtonGroup;
